import { FC } from 'react'

import { TextButton } from 'react-common'
import { useTranslation } from 'react-i18next'
import styles from './SkipToMainContentButton.module.scss'

type SkipToMainContentButtonProps = {}

export const SkipToMainContentButton: FC<SkipToMainContentButtonProps> = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.skipToMainContentButton}>
      <TextButton variant="secondary" href="#main-content" colorType="neutral">
        {t('skipToMainContent')}
      </TextButton>
    </div>
  )
}
